import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Category from '@/pages/category/page';
import Article from '@/pages/article/page';
import About from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:slug',
    element: <Category />,
  },
  {
    path: '/article/:slug',
    element: <Article />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;